import { HttpMethod, RequestOptions, useUserOrKioskRequest } from "../../common/lib/fetch";
import { Units } from "../../common/units/units";

export interface ManualWeightDto {
  ManualDeliveredAmount: number;
  ManualDeliveredUnit: Units;
}

const useReceivingAcceptManualWeight = (stagedPurchaseOrderId: string, options: RequestOptions) =>
  useUserOrKioskRequest<ManualWeightDto>({
    method: HttpMethod.POST,
    path: `/api/stagedPurchaseOrders/${stagedPurchaseOrderId}/manualWeight`
  }, options);

export default useReceivingAcceptManualWeight;
